module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton1.934c5672.jpg";